import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import { Calendar, momentLocalizer } from 'react-big-calendar'
import moment from 'moment';
import { Grid, Col, ControlLabel, Button, CheckPicker, Icon, Panel} from 'rsuite';

import Layout from '../../components/Layout';
import "react-big-calendar/lib/css/react-big-calendar.css";
import Swal from 'sweetalert2';
import $ from 'jquery';

require('moment/locale/es-mx');

const localizer = momentLocalizer(moment);

// react-big-calendar no trae español por default — sus propios textos fijos
// (Semana/Día/Mes/Hoy/etc.) se traducen vía el prop "messages", separado del
// localizer (que solo cubre nombres de mes/día, ya cubiertos por
// moment.locale). Los botones de cambio de vista están ocultos (ver
// CustomToolbar), pero otros textos del widget (p.ej. el popup de
// "+N más") sí los usan.
const CALENDAR_MESSAGES = {
    es: {
        week: 'Semana',
        work_week: 'Semana de trabajo',
        day: 'Día',
        month: 'Mes',
        previous: 'Atrás',
        next: 'Después',
        today: 'Hoy',
        agenda: 'Agenda',
    },
};

function CustomToolbar(props) {
    return (
        <div className="rbc-toolbar">
            <div className="rbc-toolbar-label">{props.label}</div>
        </div>
    )
}

class CalendarReport extends Component{
    constructor(props){
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.search = this.search.bind(this);

        this.state = {
            start_date:moment().format('YYYY-MM-DD'),
            end_date:moment().format('YYYY-MM-DD'),
            employee:[],
            employees:[],
            data:[],
            years:[],
            months:[1,2,3,4,5,6,7,8,9,10,11,12],
            value:[],
            default_date : moment().toDate(),
            events:[],
        }
    }

    async componentDidMount(){
        // Mismo idioma para moment que el resto de los reportes — moment usa
        // su propio locale global, independiente del de i18next, y el
        // localizer de react-big-calendar (nombres de mes/día en la grilla)
        // depende directamente de él.
        moment.locale(this.props.i18n.language && this.props.i18n.language.startsWith('en') ? 'en' : 'es-mx');

        var accountId  = atob(sessionStorage.getItem(btoa('account_id')));
        accountId = accountId.substring(1, accountId.length - 1);

        var req = {
            api:'accounts',
            url:'employees/by-account/'+accountId,
            method:'GET',
            requireToken:true
        }
        var employees = await this.props.fetchRequest(req);
        var data = ['Todos'];
        employees.map((e)=>{
            e.label = e.firstName +' '+ e.lastName+' '+(e.maternalSurname === null ? '' : e.maternalSurname);
            e.value = e.id
            return e;
        });

        var years = [];
        var d = new Date();
        var n = d.getFullYear();

        for (let index = n-1; index <= n; index++) {
            years.push(index);
        }

        // Igual que el resto de los reportes: cargar datos automáticamente
        // al entrar, con un filtro por defecto razonable — año/mes actuales
        // y todos los empleados de la cuenta preseleccionados.
        await this.setState({
            employees: employees,
            data: data,
            years: years,
            year: n,
            month: d.getMonth()+1,
            employee: employees.map(e => e.id)
        });

        await this.search(null, 'reports/calendar');
    }

    handleChange(e){
        this.setState({[e.target.name]: e.target.value});
    }

    async search(e, url){
        $('.rs-btn-default').blur();
        var obj = {
            year: this.state.year,
            month: this.state.month,
            employeeIds: this.state.employee
        };

        if(this.state.employee.length > 0){
            var req = {
                api: 'reports',
                url: url,
                obj: obj,
                method: 'POST',
                modal: this.props.modal_loader,
                message_modal: this.props.t('modal.spin.searching'),
                requireToken: true
            };

            var request = await this.props.fetchRequest(req);
            var list = [];

            if(request !== undefined){
                request.map(r =>
                    list.push({"start":moment(r.date).toDate(),"end":moment(r.date).toDate(),"title":r.employee.name,"absence":r.absence})
                );
            }

            var date = new Date(this.state.year,this.state.month-1,'1');

            this.setState({events: list, default_date:date});
        }else{
            Swal.fire('Error', this.props.t('error_alert.no_employee'), 'error');
        }

    }

    eventStyleGetter(event, start, end, isSelected) {
        var style = {
            backgroundColor: 'transparent',
            borderRadius: '0px',
            opacity: 0.8,
            color: event.absence === true ? 'var(--danger)' : 'var(--success)',
            border: '0px',
            display: 'block'
        };
        return {
            style: style
        };
    }

    // Este mismo renderer se usa tanto para el ícono suelto dentro de la
    // celda del mes (angosta, el nombre se trunca con "…" vía CSS) como para
    // cada fila dentro del popup de "+N más" (react-big-calendar reutiliza
    // components.month.event ahí también, con más espacio real) — mostrar
    // el nombre ahí es lo que faltaba para saber de quién es cada ícono.
    Event({ event, title }) {
        return (
            <span className="calendar-event-pill">
                <Icon icon={event.absence === true ? 'times-circle-o' : 'check-circle-o'} size="lg" />
                <span className="calendar-event-name">{title}</span>
            </span>
        );
    }

    render(){
        const {t} = this.props;
        var culture = atob(sessionStorage.getItem(btoa('lang')));

        return (
            <Layout {...this.props}>
                <Grid fluid>
                    <Col xs={24}>
                        <h3 className="s-title-page">{t('screen.reports.calendar.name')}</h3>
                    </Col>
                    <Col xs={24}>
                    <Panel className="panel-general" shaded>
                        <Col sm={8} md={4}>
                            <ControlLabel className="s-table-titles">{t('screen.reports.calendar.form.year')}</ControlLabel>
                            <select className="form-control form-control-sm" name="year" id="year"
                                value={this.state.year} onChange={(e)=>this.handleChange(e)} required >
                                    <option value="">{t('general.select')}</option>
                                    {this.state.years.map((inc, i)=>(
                                        <option key={i} value={inc}>
                                            {inc}
                                        </option>
                                    ))}
                            </select>
                        </Col>
                        <Col sm={8} md={4}>
                            <ControlLabel className="s-table-titles">{t('screen.reports.calendar.form.month')}</ControlLabel>
                            <select className="form-control form-control-sm" name="month" id="month"
                                value={this.state.month} onChange={(e)=>this.handleChange(e)} required >
                                    <option value="">{t('general.select')}</option>
                                    {this.state.months.map((inc, i)=>(
                                        <option key={i} value={inc}>
                                            {t('general.months.'+inc)}
                                        </option>
                                    ))}
                            </select>
                        </Col>
                        <Col sm={8} md={7} className="form-group">
                            <ControlLabel className="s-table-titles">{t('screen.reports.calendar.form.employee')}</ControlLabel>
                            <CheckPicker
                                id="employee"
                                value={this.state.employee}
                                onChange={(e)=>this.handleChange({target:{name:'employee', value:e}})}
                                data={this.state.employees}
                                style={{ width: '100%' }}
                                placeholder={t('general.select')}
                                // Con muchos empleados seleccionados (el caso normal, ya que
                                // se preseleccionan todos al entrar), listar cada nombre en el
                                // toggle rompe el layout completo — crece sin límite y empuja
                                // el resto de la pantalla. Mostrar solo la cuenta mantiene el
                                // toggle en una sola línea sin importar cuántos empleados haya.
                                renderValue={(value, selectedItems)=>
                                    selectedItems.length === this.state.employees.length ?
                                        t('screen.reports.calendar.form.all_selected')
                                    : selectedItems.length+' '+t('screen.reports.calendar.form.employees_selected')
                                }
                            />
                        </Col>
                        <Col sm={8} md={9} style={{marginTop:30, whiteSpace:'nowrap'}}>
                            <Button className="s-btn-primary" onClick={(e)=>this.search(e, 'reports/calendar')}>
                                {t('button.search')}
                            </Button>
                            <Button onClick={(e)=>this.props.history.goBack()} style={{marginLeft:8}}>
                                {t('button.return')}
                            </Button>
                        </Col>
                        <Col xs={24} style={{marginTop:24}}>
                            <Calendar
                                culture={culture}
                                localizer={localizer}
                                messages={CALENDAR_MESSAGES[culture]}
                                popup={true}
                                defaultDate={this.state.default_date}
                                date={this.state.default_date}
                                onNavigate={(date)=>this.setState({default_date: date})}
                                defaultView="month"
                                events={this.state.events}
                                style={{ height: "calc(100vh - 240px)" }}
                                eventPropGetter={(this.eventStyleGetter)}
                                components={{
                                    month : {event: this.Event},
                                    day : {event: this.Event},
                                    toolbar: props => <CustomToolbar {...props} t={t} />
                                }}
                            />
                        </Col>
                    </Panel>
                    </Col>
                </Grid>
            </Layout>
        )
    }
}

export default withTranslation('translations')(CalendarReport);
